<template>
  <div
    class="chat-session"
    @click="selectSession"
    :class="sessionData._id==currentSessionId?'selected-session':null"
  >
    <div class="chat-session--header">
      <div class="session-id" style="font-weight: bold">#{{ sessionData._id }}</div>
      <!-- <div class="session-timestamp">
        <div>{{new Date(sessionData.updated_at).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })}}</div>
      </div>-->
      <div class="session-timestamp text-center">
        <span class="d-block">{{$moment(sessionData.updated_at).format('MMMM Do YYYY')}}</span>
        <span class="d-block">{{$moment(sessionData.updated_at).format('h:mm a')}}</span>
      </div>
    </div>
    <div class="chat-session--inner-wrapper">
      <div class="session-id">{{ sessionData.last_message.payload || sessionData.last_message.slug}}</div>
      <div class="chat-session--channel">
        <!-- <img :src="`/img/${sessionData.channel.slug}.png`" :alt="sessionData.channel.name" /> -->
        <span>
          <supported-platforms
          class = "supported-platforms-list"
          :placeholder = "null"
          :manual-channels = "[ sessionData.channel.name.toLowerCase() ]"  />
        </span>
    
      </div>
    </div>
  </div>
</template>
<script>
import SupportedPlatforms from '../block-build/blocks/SupportedPlatforms.vue'
export default {
  props: ["sessionData", "currentSession"],
  components: {
    SupportedPlatforms
  },
  data() {
    return {
      sessionId: null,
      currentSessionId: name,
      iconsPresets: {
        whatsapp: {
          class: 'white--text green accent-4 botter-whatsapp-icon'
        },
        messenger: {
          class: 'white--text blue botter-messenger-icon'
        },
        facebook: {
          class: 'white--text blue botter-messenger-icon'
        },
        twitter: {
          class: 'white--text blue lighten-2 botter-twitter-filled-icon'
        },
        web: {
          class: 'white--text amber botter-web-icon'
        },
        'mobile-android': {
          class: 'white--text purple botter-phone-icon'
        },
        'mobile-ios' : {
          class: 'white--text purple botter-phone-icon'
        }
      }
    };
  },
  computed: {},
  created() {
    this.currentSessionId = this.currentSession;
    // console.log(
    //   new Date(this.sessionData.updated_at).toLocaleString("en-US", {
    //     hour: "numeric",
    //     minute: "numeric",
    //     hour12: true
    //   }),
    //   " sessionData"
    // );

  },
  mounted() {},
  methods: {
    selectSession() {
      this.sessionData._id !== this.currentSessionId
        ? this.$emit("sessionSelected", {
            id: this.sessionData._id,
            ...(this.sessionData.attributes && {
              attrs: this.sessionData.attributes
            })
          })
        : null;
    }
  },
  watch: {
    currentSession(val) {
      this.currentSessionId = val;
    }
  }
};
</script>
<style lang="scss" scoped>


</style>
